<div class="card-campanha" (click)="onRowClick(campanha)">
  <div class="col-code">
    <span class="col-label">Código</span>
    <span class="code-badge">#{{ codigo }}</span>
  </div>

  <div class="col-title">
    <span class="col-label">Título da Campanha</span>
    <h4 class="title-text" [title]="titulo">{{ titulo }}</h4>
  </div>

  <div class="col-meta">
    <span class="col-label">Sector</span>
    <span class="sector-pill">{{ Sector || 'Geral' }}</span>
  </div>

  <div class="col-meta">
    <span class="col-label">Objectivo</span>
    <span class="val-goal">{{ Objectivo | money }} Kz</span>
  </div>

  <div class="col-meta">
    <span class="col-label">Arrecadado</span>
    <span class="val-raised">{{ Arrecadado | money }} Kz</span>
  </div>

  <div class="col-meta">
    <span class="col-label">Data de Criação</span>
    <span class="val-date">{{ DataCriacao }}</span>
  </div>

  <div class="col-status">
    <span class="col-label">Estado</span>
    <p-tag [severity]="getSeverity(estado)" [value]="estado"></p-tag>
  </div>

  <div class="col-actions" (click)="$event.stopPropagation()">
    <p-menu
      #menuRef
      [model]="getMenuActions(campanha)"
      [popup]="true"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="10000"
    ></p-menu>

    <button type="button" class="btn-action-trigger" (click)="openMenu($event, menuRef)" title="Opções da Campanha">
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </button>
  </div>
</div>
